export function scheduleDeferredWork(
    work: () => void,
    fallbackMs: number = 15_000,
    interactionDelayMs: number = 2000,
): () => void {
    if (typeof window === 'undefined') {
        return () => undefined;
    }

    let fallbackTimerId: number | undefined;
    let interactionTimerId: number | undefined;
    let done = false;
    let interactionSeen = false;

    const cleanup = () => {
        if (typeof fallbackTimerId === 'number') {
            window.clearTimeout(fallbackTimerId);
        }
        if (typeof interactionTimerId === 'number') {
            window.clearTimeout(interactionTimerId);
        }
        window.removeEventListener('pointerdown', onFirstInteraction);
        window.removeEventListener('keydown', onFirstInteraction);
        window.removeEventListener('touchstart', onFirstInteraction);
    };

    const run = () => {
        if (done) return;
        done = true;
        cleanup();
        work();
    };

    function onFirstInteraction() {
        if (interactionSeen) return;
        interactionSeen = true;
        interactionTimerId = window.setTimeout(run, interactionDelayMs);
    }

    window.addEventListener('pointerdown', onFirstInteraction, { once: true, passive: true });
    window.addEventListener('keydown', onFirstInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', onFirstInteraction, { once: true, passive: true });
    fallbackTimerId = window.setTimeout(run, fallbackMs);

    return cleanup;
}
